/**
 * 初回メッセージ送信
 */
function send_first_message() {
    let user_id      = document.getElementById("user_id").value;
    let shop_id      = document.getElementById("shop_id").value;
    let job_offer_id = document.getElementById("job_offer_id").value;
    let action       = document.getElementById("action-url-msg").value;
    let message      = document.getElementById("message").value;
    $.ajax({
        headers: {
            'X-CSRF-TOKEN' : $('input[name="_token"]').val()
        },
        url: action,
        method: 'POST',
        data: {
            'user_id':      user_id,
            'shop_id':      shop_id,
            'job_offer_id': job_offer_id,
            'message':      message,
        },
    })
    //通信成功した時の処理
    .done(function (data) {
        if (data.code != 200) {
            $(message_error).html(data.error_msg);
            $(message_error).css('display', 'block');

        } else {
            window.location.href = data.redirect_url;
        }
        console.log(data);
    })
    //通信失敗した時の処理
    .fail(function () {
        $(message_error).html('メッセージの送信に失敗しました。お手数ですが、ページを更新して再度お試しください');
        $(message_error).css('display', 'block');
        console.log('message_error');
    });
}
window.send_first_message = send_first_message;
